import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["contenteditable"]
const _hoisted_2 = {
  key: 0,
  class: "ci-action-enter ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.tag)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["flex align-items-center tag", { editableTag: !_ctx.tag.isValidated, finalTag: _ctx.tag.isValidated }])
      }, [
        _createElementVNode("span", {
          contenteditable: !_ctx.tag.isValidated,
          ref: "tag",
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event)))
        }, _toDisplayString(_ctx.tag.text), 41, _hoisted_1),
        (!_ctx.tag.isValidated)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "ci-action-close mr-1 ml-1 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeClick()))
            }))
      ], 2))
    : _createCommentVNode("", true)
}